import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type DismissDuplicateCandidatesMutationVariables = Types.Exact<{
  input: Types.DismissDuplicateCandidatesInput;
}>;


export type DismissDuplicateCandidatesMutation = { __typename?: 'Mutation', dismissDuplicateCandidates: { __typename?: 'DuplicateCandidateIdsPayload', ids: Array<string>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RunDuplicateCheckMutationVariables = Types.Exact<{
  input: Types.RunDuplicateCheckInput;
}>;


export type RunDuplicateCheckMutation = { __typename?: 'Mutation', runDuplicateCheck: { __typename?: 'RunDuplicateCheckPayload', requestId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const DismissDuplicateCandidatesDocument = new TypedDocumentString(`
    mutation DismissDuplicateCandidates($input: DismissDuplicateCandidatesInput!) {
  dismissDuplicateCandidates(input: $input) {
    ids
    errors {
      code
      message
    }
  }
}
    `);
export const RunDuplicateCheckDocument = new TypedDocumentString(`
    mutation RunDuplicateCheck($input: RunDuplicateCheckInput!) {
  runDuplicateCheck(input: $input) {
    requestId
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    DismissDuplicateCandidates: build.mutation<DismissDuplicateCandidatesMutation, DismissDuplicateCandidatesMutationVariables>({
      query: (variables) => ({ document: DismissDuplicateCandidatesDocument, variables })
    }),
    RunDuplicateCheck: build.mutation<RunDuplicateCheckMutation, RunDuplicateCheckMutationVariables>({
      query: (variables) => ({ document: RunDuplicateCheckDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useDismissDuplicateCandidatesMutation, useRunDuplicateCheckMutation } = injectedRtkApi;
